import RestResource from '../rest.service';
import Service from '../api.service';

export default class ProjectionsChartsService extends RestResource {
  state(params) {
    return Service.get(`${this.resource}/state`, { params: params }).catch(this.handleErrors);
  }

  crop(params) {
    return Service.get(`${this.resource}/crop`, { params: params }).catch(this.handleErrors);
  }

  variety(params) {
    return Service.get(`${this.resource}/variety`, { params: params }).catch(this.handleErrors);
  }

  monthly(params) {
    return Service.get(`${this.resource}/monthly`, { params: params }).catch(this.handleErrors);
  }

  constructor() {
    super('charts/projections');
  }
}
